import gql from 'graphql-tag';

export const projectFragment = gql`
  fragment ListProjectPageProject on Project {
    id
    name
    note
  }
`;

export const getClientQL = gql`
query($id: ID!) {
  client(id: $id) {
    id
    name
    country
  }
}
`;

export const getProjectQL = gql`
  query ($projectId: ID!) {
    project (id: $projectId) {
      id
      ...ListProjectPageProject
    }
  }
  ${projectFragment}
`;

export const listProjectQL = gql`
  query listClientProject($clientId: ID!) {
    projects: listProject(client: $clientId) {
      id
      ...ListProjectPageProject
    }
  }
  ${projectFragment}
`;

